import { useSelector } from 'react-redux';
import Popup from '../../../../../shared/components/ui/popup/Popup';
import MobileBanner from '../../../../../shared/components/ui/mobileBanner/MobileBanner';
import Icon from '../../../../../shared/components/ui/icons/Icon';
import iconsList from '../../../../../shared/components/ui/icons/iconsList';
import classes from './PencilCaseMobilePopup.module.css';

const PencilCaseMobilePopup = ({ onClose }) => {
  const { texts } = useSelector(state => state.translate);

  return (
    <Popup close={onClose} dropClass={`${classes.BackdropPopup} ${classes.HideMobileHeader}`} dropClassBody={classes.PopupBody} dropClassContainer={classes.BackdropContainer}>
      <button type="button" className={classes.Close} onClick={onClose}>
        <Icon name={iconsList.x} size="31px" color="black" />
      </button>
      <div className={classes.Content}>
        <div className={classes.Intro}>
          <div className={classes.Badge}>
            <span className={classes.BadgeText}>{texts.newText}</span>
          </div>
          <div className={classes.Headings}>
            <p className={classes.Heading}>{texts.newInVirtualSchoolExclaim}</p>
            <p className={classes.Title}>{texts.myPencilCase}</p>
          </div>
          <p className={classes.Description}>{texts.pencilCasePromoDescription}</p>
        </div>
        <MobileBanner className={classes.MobileBanner} text={texts.availableOnDesktopOnly} />
      </div>
    </Popup>
  );
};

export default PencilCaseMobilePopup;
